import styled from '@emotion/styled';
import React from 'react';
import DoneIcon from 'ud-ui/components/icon/done-icon';
import { theme } from 'styles/theme/theme';

function Checkbox(props: IProps) {
  const { checked, onChange } = props;

  return (
    <MainBlock checked={checked} onClick={onChange} className={'flex-center'}>
      {/* Галочка тёмная: белая на жёлтом даёт 2.0:1, тёмная — 8.5:1. Раньше она
          рендерилась всегда и в снятом состоянии пряталась только за счёт того,
          что была белой на белом. */}
      {checked && <DoneIcon color={theme.colors.SurfaceRaisinBlack50} width={10} height={10} />}
    </MainBlock>
  );
}

interface IProps {
  checked: boolean;
  onChange: () => void;
}

export default Checkbox;

const MainBlock = styled.div<{ checked: boolean }>`
  background: ${({ checked }) => (checked ? theme.colors.AccentNaplesYellow : theme.colors.SurfaceWhite)};
  border: 1px solid ${({ checked }) => (checked ? 'transparent' : theme.colors.Gray)};
  border-radius: 4px;
  width: 16px;
  height: 16px;
`;
